export const sanitizePhoneNumber = (number) => number.replace(/[^0-9+]/g, '');
